export default "__VITE_ASSET__RZJIKoZp__"